import React, { useState, useEffect } from "react";
import * as XLSX from "xlsx"; // Import SheetJS
import SellerNavbar from "../../component/SellerNavbar";
import { baseurl } from "../../Baseurl";
import axios from "axios";
import { Download } from "react-feather";
import sheet from "../../component/file/aras_bulk_upload_sheet.xlsx";
import Swal from "sweetalert2"; 


const SellerBulkUpload = () => {
  const [excelData, setExcelData] = useState([]); // Store uploaded Excel data
  const [formData, setFormData] = useState({
    listingStandard: "", // Must exist
    listingCondition: "", // Must exist
    listingType: "", // Must exist
  });
  


  const [menus, setMenus] = useState([]);
  const [mainCategories, setMainCategories] = useState([]);
  const [subCategories, setSubCategories] = useState([]);
  const [subSubCategories, setSubSubCategories] = useState([]);
  const [subSubSubCategories, setSubSubSubCategories] = useState([]);
  const [finalCategories, setFinalCategories] = useState([]);
  const [sixCategories, setSixCategories] = useState([]);
  const [seventhCategories, setSeventhCategories] = useState([]);
  const [eightCategories, setEightCategories] = useState([]);
  const [nineCategories, setNineCategories] = useState([]);
  
 

  const [selectedMainCategory, setSelectedMainCategory] = useState("");
  const [selectedSubCategory, setSelectedSubCategory] = useState("");
  const [selectedSubSubCategory, setSelectedSubSubCategory] = useState("");
  const [selectedSubSubSubCategory, setSelectedSubSubSubCategory] = useState("");
  const [selectedFinalCategory, setSelectedFinalCategory] = useState("");
  const [selectedSixCategory, setSelectedSixCategory] = useState("");
  const [selectedSeventhCategory, setSelectedSeventhCategory] = useState("");
  const [selectedEightCategory, setSelectedEightCategory] = useState("");
  const [selectedNineCategory, setSelectedNineCategory] = useState("");
  
// Fetch Menus
useEffect(() => {
  axios
    .get(`${baseurl}getMenus`)
    .then((response) => {
      setMenus(response.data);
      setMainCategories(response.data.filter(menu => menu.parent_id === null));
    })
    .catch((error) => console.error("Error fetching menus:", error));
}, []);

// Handle dropdown changes
const handleMainCategoryChange = (e) => {
  const selectedId = parseInt(e.target.value);
  setSelectedMainCategory(selectedId);
  setSubCategories(menus.filter(menu => menu.parent_id === selectedId));

  // Reset all lower-level categories
  setSelectedSubCategory("");
  setSubSubCategories([]);
  setSelectedSubSubCategory("");
  setSubSubSubCategories([]);
  setSelectedSubSubSubCategory("");
  setFinalCategories([]);
  setSelectedFinalCategory("");
  setSixCategories([]);
  setSelectedSixCategory("");
  setSeventhCategories([]);
  setSelectedSeventhCategory("");
  setEightCategories([]);
  setSelectedEightCategory("");
  setNineCategories([]);
  setSelectedNineCategory("");
};

const handleSubCategoryChange = (e) => {
  const selectedId = parseInt(e.target.value);
  setSelectedSubCategory(selectedId);
  setSubSubCategories(menus.filter(menu => menu.parent_id === selectedId));

  // Reset lower categories
  setSelectedSubSubCategory("");
  setSubSubSubCategories([]);
  setSelectedSubSubSubCategory("");
  setFinalCategories([]);
  setSelectedFinalCategory("");
  setSixCategories([]);
  setSelectedSixCategory("");
  setSeventhCategories([]);
  setSelectedSeventhCategory("");
  setEightCategories([]);
  setSelectedEightCategory("");
  setNineCategories([]);
  setSelectedNineCategory("");
};

const handleSubSubCategoryChange = (e) => {
  const selectedId = parseInt(e.target.value);
  setSelectedSubSubCategory(selectedId);
  setSubSubSubCategories(menus.filter(menu => menu.parent_id === selectedId));

  // Reset lower categories
  setSelectedSubSubSubCategory("");
  setFinalCategories([]);
  setSelectedFinalCategory("");
  setSixCategories([]);
  setSelectedSixCategory("");
  setSeventhCategories([]);
  setSelectedSeventhCategory("");
  setEightCategories([]);
  setSelectedEightCategory("");
  setNineCategories([]);
  setSelectedNineCategory("");
};

const handleSubSubSubCategoryChange = (e) => {
  const selectedId = parseInt(e.target.value);
  setSelectedSubSubSubCategory(selectedId);
  setFinalCategories(menus.filter(menu => menu.parent_id === selectedId));

  // Reset lower categories
  setSelectedFinalCategory("");
  setSixCategories([]);
  setSelectedSixCategory("");
  setSeventhCategories([]);
  setSelectedSeventhCategory("");
  setEightCategories([]);
  setSelectedEightCategory("");
  setNineCategories([]);
  setSelectedNineCategory("");
};

const handleFinalCategoryChange = (e) => {
  const selectedId = parseInt(e.target.value);
  setSelectedFinalCategory(selectedId);
  setSixCategories(menus.filter(menu => menu.parent_id === selectedId));

  // Reset 6th, 7th, 8th, and 9th level categories
  setSelectedSixCategory("");
  setSeventhCategories([]);
  setSelectedSeventhCategory("");
  setEightCategories([]);
  setSelectedEightCategory("");
  setNineCategories([]);
  setSelectedNineCategory("");
};

const handleSixCategoryChange = (e) => {
  const selectedId = parseInt(e.target.value);
  setSelectedSixCategory(selectedId);
  setSeventhCategories(menus.filter(menu => menu.parent_id === selectedId));

  // Reset 7th, 8th, and 9th level categories
  setSelectedSeventhCategory("");
  setEightCategories([]);
  setSelectedEightCategory("");
  setNineCategories([]);
  setSelectedNineCategory("");
};

const handleSeventhCategoryChange = (e) => {
  const selectedId = parseInt(e.target.value);
  setSelectedSeventhCategory(selectedId);
  setEightCategories(menus.filter(menu => menu.parent_id === selectedId));

  // Reset 8th and 9th level categories
  setSelectedEightCategory("");
  setNineCategories([]);
  setSelectedNineCategory("");
};

const handleEightCategoryChange = (e) => {
  const selectedId = parseInt(e.target.value);
  setSelectedEightCategory(selectedId);
  setNineCategories(menus.filter(menu => menu.parent_id === selectedId));

  // Reset 9th level category
  setSelectedNineCategory("");
};

const handleNineCategoryChange = (e) => {
  const selectedId = parseInt(e.target.value);
  setSelectedNineCategory(selectedId);
};

// const handleInputChange = (e) => {
//   const { name, value } = e.target;
//   setFormData({ ...formData, [name]: value });
// };





  // Handle File Upload and Parse XLSX
  const handleFileUpload = (event) => {
    const file = event.target.files[0];
    if (!file) return;

    const reader = new FileReader();
    reader.readAsArrayBuffer(file);

    reader.onload = (e) => {
      const bufferArray = e.target.result;
      const wb = XLSX.read(bufferArray, { type: "array" });
      const wsname = wb.SheetNames[0];
      const ws = wb.Sheets[wsname];
      let jsonData = XLSX.utils.sheet_to_json(ws);

      // Replace empty cells with '-'
      jsonData = jsonData.map((row) =>
        Object.fromEntries(
          Object.entries(row).map(([key, value]) => [key, value || "-"])
        )
      );

      setExcelData(jsonData);
    };

    reader.onerror = (error) => {
      console.error("File reading error:", error);
    };
  };

  const seller_id = localStorage.getItem("seller_id");


  const handleInputChange = (e) => {
    const { name, value } = e.target;
    
    setFormData((prevData) => {
      console.log("Updating state:", { ...prevData, [name]: value });
      return { ...prevData, [name]: value };
    });
  };
  // Handle Upload Data to Backend
 

  
  const handleUploadData = async () => {
    if (excelData.length === 0) {
      Swal.fire("Error", "No data to upload!", "error");
      return;
    }
  
    // Attach seller_id to each product
    const updatedExcelData = excelData.map((product) => ({
      ...product,
      seller_id,
    }));
  
    // ✅ Send JSON directly instead of FormData
    const payload = {
      products: updatedExcelData,
      listingStandard: formData.listingStandard || "",
      listingCondition: formData.listingCondition || "",
      listingType: formData.listingType || "",
      category:
        selectedNineCategory ||
        selectedEightCategory ||
        selectedSeventhCategory ||
        selectedSixCategory ||
        selectedFinalCategory ||
        selectedSubSubSubCategory ||
        selectedSubSubCategory ||
        selectedSubCategory ||
        selectedMainCategory ||
        null,
    };
  
    console.log("Sending JSON Payload to Backend:", payload);
  
    try {
      const response = await axios.post(`${baseurl}/insertListingBulk`, payload, {
        headers: {
          "Content-Type": "application/json", // ✅ Ensure JSON format
        },
      });
  
      console.log("Response:", response.data);
  
      // ✅ Show SweetAlert2 success message and reload after "OK"
      Swal.fire({
        title: "Success!",
        text: "Data uploaded successfully!",
        icon: "success",
        confirmButtonText: "OK",
      }).then(() => {
        window.location.reload(); // Reload the page after clicking "OK"
      });
    } catch (error) {
      console.error("Upload error:", error.response ? error.response.data : error.message);
  
      // ❌ Show error message using SweetAlert2
      Swal.fire({
        title: "Upload Failed",
        text: "An error occurred while uploading data.",
        icon: "error",
        confirmButtonText: "OK",
      });
    }
  };
  


  return (
    <>
      <SellerNavbar />
      <div>
        <section className="mb-5">
          <div className="container-fluid">
            <div className="row my-3 g-2 justify-content-center">
              <div className="col-md-12">
                <div className="reviewcls text-start">
                  <div className="d-flex justify-content-between align-items-center">
                    <div className="me-3">
                      <h4 className="selh1">Bulk Listing</h4>
                    </div>
                    <div>
                      <input
                        type="file"
                        className="form-control"
                        accept=".xlsx, .xls"
                        onChange={handleFileUpload}
                      />
                    </div>

                    <div>
                      <a href={sheet} download className="btn submitbtnn">
                        <Download size={19} />
                        &nbsp;Download Format
                      </a>
                    </div>
                  </div>

                  <hr />

                  {/* Display Uploaded Data without Dropdowns */}
                  {excelData.length > 0 && (
                    <div>


<div className="row mb-3 g-2">

              {/* Main Category */}
              <div className="col-md-4">
                <label className="form-label">Item Category</label>
                <select className="form-select" value={selectedMainCategory} onChange={handleMainCategoryChange}>
                  <option value="">Select Main Category</option>
                  {mainCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
                </select>
              </div>

              {/* Other dropdowns (Sub Categories) */}
              {subCategories.length > 0 && (
                <div className="col-md-4">
                  <label className="form-label">Sub Category</label>
                  <select className="form-select" value={selectedSubCategory} onChange={handleSubCategoryChange}>
                    <option value="">Select Sub Category</option>
                    {subCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
                  </select>
                </div>
              )}

 {/* Sub-Sub Category */}
      {subSubCategories.length > 0 && (
        <div className="col-md-4">
          <label className="form-label">Make/Brand</label>
          <select className="form-select" value={selectedSubSubCategory} onChange={handleSubSubCategoryChange}>
            <option value="">Select Sub-Sub Category</option>
            {subSubCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
          </select>
        </div>
      )}

      {/* Sub-Sub-Sub Category */}
      {/* Sub-Sub-Sub Category */}
      {subSubSubCategories.length > 0 && (
          <div className="col-md-4">
            <label className="form-label">Instrument Type</label>
            <select className="form-select" value={selectedSubSubSubCategory} onChange={handleSubSubSubCategoryChange}>
              <option value="">Select Instrument Type</option>
              {subSubSubCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
            </select>
          </div>
        )}

        {/* Final Category */}
 {/* Final Category */}
 {finalCategories.length > 0 && (
<div className="col-md-4">
  <label className="form-label">Final Category</label>
  <select className="form-select" value={selectedFinalCategory} onChange={handleFinalCategoryChange}>
    <option value="">Select Final Category</option>
    {finalCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>
 )}
{/* 6th Level Category */}
{sixCategories.length > 0 && (
<div className="col-md-4">
  <label className="form-label">6th Level Category</label>
  <select className="form-select" value={selectedSixCategory} onChange={handleSixCategoryChange}>
    <option value="">Select 6th Level Category</option>
    {sixCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>
)}
{/* 7th Level Category */}

{seventhCategories.length > 0 && (
<div className="col-md-4">
  <label className="form-label">7th Level Category</label>
  <select className="form-select" value={selectedSeventhCategory} onChange={handleSeventhCategoryChange}>
    <option value="">Select 7th Level Category</option>
    {seventhCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>
)}
{/* 8th Level Category */}
{eightCategories.length > 0 && (
<div className="col-md-4">
  <label className="form-label">8th Level Category</label>
  <select className="form-select" value={selectedEightCategory} onChange={handleEightCategoryChange}>
    <option value="">Select 8th Level Category</option>
    {eightCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>
)}
{/* 9th Level Category */}
{nineCategories.length > 0 && (
<div className="col-md-4">
  <label className="form-label">9th Level Category</label>
  <select className="form-select" value={selectedNineCategory} onChange={handleNineCategoryChange}>
    <option value="">Select 9th Level Category</option>
    {nineCategories.map(menu => <option key={menu.id} value={menu.id}>{menu.title}</option>)}
  </select>
</div>
)}
</div>



<div className="row mb-3">
<div className="col-md-4">
                        <label htmlFor="listingCondition" className="form-label">
                          Listing Condition<span className="text-danger">*</span>
                        </label>
                        <select
                          id="listingCondition"
                          name="listingCondition"
                          className="form-control"
                          value={formData.listingCondition}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select a condition</option>
                          <option value="used">Used</option>
                          <option value="new">New</option>
                          <option value="refurbished">Refurbished</option>
                          <option value="forParts">For Parts/Not Working</option>
                          <option value="notSpecified">Not Specified</option>
                        </select>
                       
                      </div>

                      <div className="col-md-4">
                        <label htmlFor="listingType" className="form-label">
                          Listing Type<span className="text-danger">*</span>
                        </label>
                        <select
                          id="listingType"
                          name="listingType"
                          className="form-control"
                          value={formData.listingType}
                          onChange={handleInputChange}
                          required
                        > 
                          <option value="directSell">Direct Sell</option>
                          <option value="quoteRequest">Request A Quote</option> 
                        </select>
                       
                      </div>
                      <div className="col-md-4">
                        <label htmlFor="listingStandard" className="form-label">
                          Listing Standard<span className="text-danger">*</span>
                        </label>
                        <select
                          id="listingStandard"
                          name="listingStandard"
                          className="form-control"
                          value={formData.listingStandard}
                          onChange={handleInputChange}
                          required
                        >
                          <option value="">Select a Standard</option>
                          <option value="Piece (pc)">Piece (pc)</option>
                          <option value="Set (set) of">Set (set) of</option>
                          <option value="Pack (pack) of">Pack (pack) of</option> 
                          <option value="Box (box) of">Box (box) of</option> 
                          <option value="Gram (g)">Gram (g)</option> 
                          <option value="Kilogram (kg)">Kilogram (kg)</option> 
                          <option value="Milligram (mg)">Milligram (mg)</option> 
                          <option value="Ton (t)">Ton (t)</option> 
                          <option value="Millimeter (mm)">Millimeter (mm)</option> 
                          <option value="Centimeter (cm)">Centimeter (cm)</option> 
                          <option value="Meter (m)">Meter (m)</option> 
                          <option value="Inche (in)">Inche (in)</option> 
                          <option value="Foot (ft)">Foot (ft)</option> 
                          <option value="Milliliter (ml)">Milliliter (ml)</option> 
                          <option value="Liter (l)">Liter (l)</option> 
                          <option value="Cubic Centimeter (cc)">Cubic Centimeter (cc)</option> 
                          <option value="Cubic Meter (m3)">Cubic Meter (m3)</option> 
                        </select>
                         
                      </div>

</div>






                      <div className="table-responsive">
                        <table className="table table-bordered">
                          <thead className="table-dark">
                            <tr>
                              {Object.keys(excelData[0]).map((key, index) => (
                                <th key={index}>{key}</th>
                              ))}
                            </tr>
                          </thead>
                          <tbody>
                            {excelData.map((row, rowIndex) => (
                              <tr key={rowIndex}>
                                {Object.keys(row).map((col, colIndex) => (
                                  <td key={colIndex}>{row[col]}</td>
                                ))}
                              </tr>
                            ))}
                          </tbody>
                        </table>
                      </div>

                      {/* Upload Data Button */}
                      <button
                        className="btn btn-primary mt-3"
                        onClick={handleUploadData}
                      >
                        Upload Data
                      </button>
                    </div>
                  )}
                </div>
              </div>
            </div>
          </div>
        </section>
      </div>
    </>
  );
};

export default SellerBulkUpload;
